
const digest = '95d9671fb9bbbad42cba2a95f3e9cca2556c19e8ad456dd695dd0dfcabbc1e33';
const classes = {"list":"_list_1j9k7_1","editButtonRow":"_editButtonRow_1j9k7_9","item":"_item_1j9k7_15","label":"_label_1j9k7_27","removeButton":"_removeButton_1j9k7_33"};
const css = `._list_1j9k7_1 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: stretch;
}

._editButtonRow_1j9k7_9 {
  display: flex;
  align-items: center;
  align-self: flex-end;
}

._item_1j9k7_15 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  font-weight: 400;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  color: #3e3f42;
}

._label_1j9k7_27 {
  flex: 1;
  min-width: 0;
  text-align: right;
}

._removeButton_1j9k7_33 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
}
._removeButton_1j9k7_33:hover {
  opacity: 0.85;
}
._removeButton_1j9k7_33:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  outline-offset: 1px;
}
._removeButton_1j9k7_33 img {
  display: block;
  width: 16px;
  height: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  